<template>
  <div >
    <h5>Horses</h5>
    <table class="table" v-if="horses.length > 0">
      <thead >
        <tr>
          <th scope="col">Name</th>
          <th scope="col">Score</th>
          <th scope="col">Odds</th>
          <th scope="col">Winner</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="horse in horses">
          <td>{{horse.name}}</td>
          <td>{{horse.score? horse.score.toFixed(5) : "-"}}</td>
          <td>{{horse.oddsNumber? horse.oddsNumber.toFixed(2): "-"}}</td>
          <td >
            <i class="material-icons md-24 clickable" v-if="horse.winner" >check_circle</i>
            <i class="material-icons md-24 clickable" v-if="!horse.winner && horse.predictedWinner && horse.position" >cancel</i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'RunnersTable',
  props:  ['horses'],
  components: {
  },
  data () {
    return {
      title: 'RunnersTable'
    }
  },
  watch: {

  },
  methods: {

  },
  mounted () {

  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
